import { isNil, omitBy } from 'lodash-es'

export const withDefaultProps =
  <T extends object>(defaults: Partial<T>) =>
  (props: T): Omit<T, 'ref'> => ({ ...defaults, ...(omitBy(props, isNil) as T) })
